var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 595.3",
    style: {
      enableBackground: "new 0 0 595.3 595.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M297.6,595.3C133.5,595.3,0,461.8,0,297.7S133.5,0,297.6,0s297.6,133.5,297.6,297.7S461.7,595.3,297.6,595.3z M297.6,50.2 c-136.4,0-247.5,111-247.5,247.5c0,136.4,111,247.5,247.5,247.5s247.5-111,247.5-247.5C545.1,161.2,434.1,50.2,297.6,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.6,595.3c-83.4,0-146.2-128-146.2-297.6C151.4,128,214.3,0,297.6,0s146.2,128,146.2,297.7 C443.9,467.3,381,595.3,297.6,595.3z M297.6,50.2c-45.3,0-96.1,105.8-96.1,247.5s50.7,247.5,96.1,247.5s96.1-105.8,96.1-247.5 S343,50.2,297.6,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.2,322.7H25.1C11.2,322.7,0,311.5,0,297.7s11.2-25.1,25.1-25.1h545.1c13.8,0,25.1,11.2,25.1,25.1 S584,322.7,570.2,322.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.4857a7a1a13b045083f54eaa24b8f152.svg";
export { ForwardRef as ReactComponent };